// extracted by mini-css-extract-plugin
module.exports = {"promotional-message":"promotional-message-element-module__promotional-message__J2QkH"};